import { CreateQueryMode } from '../../models/filter-condition.model';
import { TableColumn } from '../../models/TableColumn.model';
export const Standard = 'Standard';
export const project = 'project';

export const BUSINESS_LINE_OPTIONS: { id: string; name: string }[] = [
  { id: 'SHS US', name: 'SHS US' },
  { id: 'SHS DX LS', name: 'SHS DX LS' },
  { id: 'SHS CI RO', name: 'SHS CI RO' },
  { id: 'SHS DI MR', name: 'SHS DI MR' },
  { id: 'SHS DI CT', name: 'SHS DI CT' },
  { id: 'SHS CI PT', name: 'SHS CI PT' },
  { id: 'SHS DI MI', name: 'SHS DI MI' },
  { id: 'SHS DI DA', name: 'SHS DI DA' },
  { id: 'SHS DI XP', name: 'SHS DI XP' },
  { id: 'SHS DX SLS - MD', name: 'SHS DX SLS - MD' },
  { id: 'SHS AT AX', name: 'SHS AT AX' },
  { id: 'SHS DX POC', name: 'SHS DX POC' },
];

const TF_BOOLEAN_OPTIONS = [
  { value: 'T', label: 'True' },
  { value: 'F', label: 'False' },
];

const TF_LOWERCASE_OPTIONS = [
  { value: 'T', label: 'true' },
  { value: 'F', label: 'false' },
];

const YN_OPTIONS = [
  { value: 'Y', label: 'Y' },
  { value: 'N', label: 'N' },
];

const CONTRACT_STATUS_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
  { value: 'Cancelled', label: 'Cancelled' },
];

const SOFTWARE_COVERAGE_OPTIONS = [
  {
    value: 'Software distribution is covered by the service contract',
    label: 'Software distribution is covered by the service contract',
  },
  {
    value: 'Software distribution and remote installation service is covered by the service contract',
    label: 'Software distribution and remote installation service is covered by the service contract',
  },
  {
    value: 'Software distribution, remote installation, service and training is covered by the service contract',
    label: 'Software distribution, remote installation, service and training is covered by the service contract',
  },
];

export const TABLE_CONST_COLUMNS: TableColumn[] = [
  {
    colName: 'REL_SYS_EQ_ID',
    displayName: 'Related System EQ ID',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_ID_HQ',
    displayName: 'Equipment Number HQ',
    visible: true,
    isFilterable: true,
    filterType: 'text',
    isFixed: true,
  },
  {
    colName: 'EQ_ID_RU',
    displayName: 'Equipment Number RU',
    visible: false,
    isFilterable: true,
    filterType: 'text',
    isFixed: true,
  },
  {
    colName: 'REL_SYS_MAT_IVK_NAME',
    displayName: 'IVK Description',
    visible: true,
    isFilterable: true,
    filterType: 'text',
    isFixed: true,
  },
  {
    colName: 'MAT_IVK_NAME',
    displayName: 'IVK Description',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_ID',
    displayName: 'CI Number - EQ ID',
    visible: true,
    isFilterable: true,
    filterType: 'text',
    isFixed: true,
  },
  {
    colName: 'EQ_MAT_ID',
    displayName: 'Material No',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SERIAL_ID',
    displayName: 'Serial No',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_TECH_ID',
    displayName: 'Technical Ident',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_TYPE',
    displayName: 'EQ Type',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SUBTYPE',
    displayName: 'EQ Subtype',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },

  {
    colName: 'EQ_STATUS',
    displayName: 'EQ Status',
    visible: true,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'Active', label: 'Active' },
      { value: 'Inactive', label: 'Inactive' },
    ],
  },
  {
    colName: 'EQ_SUB_STATUS',
    displayName: 'EQ Substatus',
    visible: true,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'Shipped', label: 'Shipped' },
      { value: 'Location unknown', label: 'Location unknown' },
      { value: 'License Move', label: 'License Move' },
      { value: 'On Stock', label: 'On stock' },
      { value: 'HW - Change Change', label: 'HW - Change Change' },
      { value: 'N', label: 'N' },
      { value: 'Returned', label: 'Returned' },
      { value: 'EVOLVE', label: 'EVOLVE' },
      { value: 'Scrapped', label: 'Scrapped' },
      { value: 'Expired', label: 'Expired' },
      { value: 'HW-Change', label: 'HW-Change' },
      { value: 'Active', label: 'Active' },
      { value: 'Unknown', label: 'Unknown' },
      { value: 'Deleted', label: 'Deleted' },
    ],
  },
  {
    colName: 'WS_EQ_IDS',
    displayName: 'Workstation CI Number(s)',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'WS_MAT_IDS',
    displayName: 'Workstation Material No(s)',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'WS_SERIAL_IDS',
    displayName: 'Workstation Serial No(s)',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'CMP_EQ_IDS',
    displayName: 'Component CI Number(s)',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'CMP_MAT_IDS',
    displayName: 'Component Material No(s)',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'CMP_SERIAL_IDS',
    displayName: 'Component Serial No(s)',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'LIC_EQ_IDS',
    displayName: 'License CI Number(s)',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'LIC_MAT_IDS',
    displayName: 'License Material No(s)',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'LIC_SERIAL_IDS',
    displayName: 'License Serial No(s)',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SW_VS',
    displayName: 'Software Version',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SW_VS_CHG_DT',
    displayName: 'SW Change date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SW_VS_VERIFY_DT',
    displayName: 'SW Verify date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_UP_ID_SW_VS_CHG',
    displayName: 'SW Change Update No',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_RUH_FLG',
    displayName: 'RUH Ready Flag',
    visible: true,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: TF_LOWERCASE_OPTIONS,
  },
  {
    colName: 'EQ_NORUH_FLG',
    displayName: 'RUH Not Allowed by Customer',
    visible: true,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: TF_LOWERCASE_OPTIONS,
  },
  {
    colName: 'EQ_RUH_READY_SOURCE_FLG',
    displayName: 'RSWD Environment',
    visible: true,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'CLASSIC', label: 'CLASSIC' },
      { value: 'NUCLEUS', label: 'NUCLEUS' },
      { value: 'NG', label: 'NG' },
    ],
  },
  {
    colName: 'EQ_ASU_FLG',
    displayName: 'ASU Ready Flag',
    visible: true,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: YN_OPTIONS,
  },
  {
    colName: 'EQ_NOASU_FLG',
    displayName: 'ASU Not Allowed by Customer',
    visible: true,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: YN_OPTIONS,
  },
  {
    colName: 'SYS_EMBARGO_FLG',
    displayName: 'Embargo Flag',
    visible: true,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: TF_BOOLEAN_OPTIONS,
  },
  {
    colName: 'EQ_INHOUSE_PROD_FLG',
    displayName: 'Inhouse Flag',
    visible: true,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [{ value: 'P', label: 'P' }],
  },
  {
    colName: 'EQ_REFURB_FLG',
    displayName: 'Refurbished / Reconditioned',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'Y', label: 'Y' },
      { value: 'N', label: 'N' },
      { value: 'X', label: 'X' },
      { value: 'R', label: 'R' },
    ],
  },
  {
    colName: 'EQ_DEALER',
    displayName: 'Dealer Flag',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'LEVEL_BL_TEXT',
    displayName: 'Business Line',
    visible: true,
    isFilterable: true,
    filterType: 'select',
    selectOptions: BUSINESS_LINE_OPTIONS.map((bl) => ({
      value: bl.id,
      label: bl.name,
    })),
  },
  {
    colName: 'EQ_DEMO_FLG',
    displayName: 'Demo Flag',
    visible: false,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: YN_OPTIONS,
  },
  {
    colName: 'EQ_COUNTRY_ID',
    displayName: 'Country',
    visible: true,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [],
  },
  {
    colName: 'EQ_SERVICE_PARTNER_ID',
    displayName: 'Service Partner',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SERVICE_PARTNER_TXT',
    displayName: 'Service Partner Name',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SERVICE_PARTNER_TYPE',
    displayName: 'Service Partner Type',
    visible: true,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'P', label: 'P' },
      { value: 'O', label: 'O' },
      { value: 'I', label: 'I' },
      { value: 'C', label: 'C' },
    ],
  },
  {
    colName: 'EQ_SYS_UP_PRIORITY',
    displayName: 'Update Handling Priority',
    visible: true,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'm', label: 'm' },
      { value: 'l', label: 'l' },
      { value: 'h', label: 'h' },
    ],
  },
  {
    colName: 'EQ_SERVICE_PARTNER_TYPE_DESCRIPTION',
    displayName: 'Service Partner Type Description',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SERVICE_PARTNER_COUNTRY_ID',
    displayName: 'Service Partner Country',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SERVICE_PARTNER_COUNTRY_RSP',
    displayName: 'SP responsible for Country',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_DELIVERY_DT',
    displayName: 'Delivery Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_INSTALL_DT',
    displayName: 'Install Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_WARRANTY_HQ_RU_START_DT',
    displayName: 'BL Warranty Start Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_WARRANTY_HQ_RU_END_DT',
    displayName: 'BL Warranty End Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_WARRANTY_RU_CUST_START_DT',
    displayName: 'Customer Warranty Start Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_WARRANTY_RU_CUST_END_DT',
    displayName: 'Customer Warranty End Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_VENDOR_WARRANTY_START_DT',
    displayName: 'Vendor Warranty Start Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_VENDOR_WARRANTY_END_DT',
    displayName: 'Vendor Warranty End Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_EOS_FLG',
    displayName: 'EoS Flag',
    visible: false,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: YN_OPTIONS,
  },
  {
    colName: 'EQ_EOD_DT',
    displayName: 'End of Delivery Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_EOS_DT',
    displayName: 'End of Service Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_EOS_UP_ID',
    displayName: 'EP Update Number',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SERVICE_PROVIDER_TYPE',
    displayName: 'Service Provider Type',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'ISO', label: 'ISO' },
      { value: 'TEST_SITE', label: 'TEST_SITE' },
      { value: 'ISM', label: 'ISM' },
      { value: 'DEMO', label: 'DEMO' },
      { value: 'ES', label: 'ES' },
      { value: 'N', label: 'N' },
      { value: 'IN_HOUSE', label: 'IN_HOUSE' },
      { value: 'SP', label: 'SP' },
      { value: 'LOANER', label: 'LOANER' },
    ],
  },
  {
    colName: 'EQ_SOLUTION_FLG',
    displayName: 'EQ Solution Flag',
    visible: false,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: YN_OPTIONS,
  },
  {
    colName: 'EQ_SUBCLASS1_TEXT',
    displayName: 'Sub Class 1',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SUBCLASS2_TEXT',
    displayName: 'Sub Class 2',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SUBCLASS3_TEXT',
    displayName: 'Sub Class 3',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SUBCLASS4_TEXT',
    displayName: 'Sub Class 4',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SUBCLASS5_TEXT',
    displayName: 'Sub Class 5',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_SUBCLASS6_TEXT',
    displayName: 'Sub Class 6',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_CTH_FLG',
    displayName: 'CTH Flag',
    visible: false,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: YN_OPTIONS,
  },
  {
    colName: 'EQ_ES_FLG',
    displayName: 'ES Flag',
    visible: false,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: YN_OPTIONS,
  },
  {
    colName: 'EQ_HARDWARE_VERSION',
    displayName: 'Hardware Version',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_FL_ID',
    displayName: 'Functional Location',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'FL_NAME_2',
    displayName: 'F/L Name 2',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'FL_NAME_1',
    displayName: 'F/L Name 1',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'FL_STREET_AND_ID',
    displayName: 'F/L Street',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'FL_ZIP',
    displayName: 'F/L Postal Code',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'FL_CITY',
    displayName: 'F/L City',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'FL_COUNTRY_ID',
    displayName: 'F/L Country',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'LIC_CREATION_DT',
    displayName: 'License Creation Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'LIC_START_DT',
    displayName: 'License Start Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'LIC_END_DT',
    displayName: 'License End Date',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'MAT_GTIN_ID',
    displayName: 'GTIN',
    visible: true,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'ITCAREPLAN',
    displayName: 'DA IT CARE PLAN',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'No Contract', label: 'No Contract' },
      { value: 'TOP Type', label: 'TOP Type' },
      { value: 'Warranty', label: 'Warranty' },
      { value: 'PRO Type', label: 'PRO Type' },
      {
        value: 'Service Package syngo.via Excel',
        label: 'Service Package syngo.via Excel',
      },
      { value: 'Others', label: 'Others' },
    ],
  },
  {
    colName: 'ITCPEDATE',
    displayName: 'DA IT CPE DATE',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'ITCPSDATE',
    displayName: 'DA IT CPS DATE',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'SOFTUPDATES',
    displayName: 'DA SOFT UPDATES',
    visible: false,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: TF_BOOLEAN_OPTIONS,
  },
  {
    colName: 'SOFTUPDATESVAL',
    displayName: 'DA SOFT UPDATES VAL',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      {
        value: 'Software and onsite installation service is covered by service contract',
        label: 'Software and onsite installation service is covered by service contract',
      },
      {
        value: 'Software distribution, remote installation, service and training is covered by service contract',
        label: 'Software distribution, remote installation, service and training is covered by service contract',
      },
      ...SOFTWARE_COVERAGE_OPTIONS,
    ],
  },

  {
    colName: 'SOFTUPGRADE',
    displayName: 'DA SOFT UPGRADE',
    visible: false,
    isFilterable: true,
    filterType: 'booleanSelect',
    selectOptions: TF_BOOLEAN_OPTIONS,
  },
  {
    colName: 'SOFTUPGRADEVAL',
    displayName: 'DA SOFT UPGRADE VAL',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'Full system', label: 'Full system' },
      ...SOFTWARE_COVERAGE_OPTIONS,
      {
        value: 'Software and onsite installation service is covered by the service contract',
        label: 'Software and onsite installation service is covered by the service contract',
      },
    ],
  },
  {
    colName: 'UP_UPDATE_ID',
    displayName: 'Update Number',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'UP_SRS_STATUS',
    displayName: 'SRS Update Status',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
    {
    colName: 'UP_CI_STATUS',
    displayName: 'SAP Update Status',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'ESC1', label: 'ESC1' },
      { value: 'ESC2', label: 'ESC2' },
      { value: 'ESC3', label: 'ESC3' },
      { value: 'OPEN', label: 'OPEN' },
      { value: 'PERF', label: 'PERF' },
      { value: 'CANC', label: 'CANC' },
      { value: 'FADE', label: 'FADE' },
      { value: 'HOLD', label: 'HOLD' },
      { value: 'NOAF', label: 'NOAF' },
      { value: 'NOAP', label: 'NOAP' },
      { value: 'REPL', label: 'REPL' },
      { value: 'CINF', label: 'CINF' },
      { value: 'CREF', label: 'CREF' },
      { value: 'UNIN', label: 'UNIN' },
      { value: 'RREF', label: 'RREF' },
      { value: 'RINF', label: 'RINF' },
      { value: 'RPER', label: 'RPER' },
      { value: 'RFAI', label: 'RFAI' },
      { value: 'ROPE', label: 'ROPE' },
      { value: 'OEMP', label: 'OEMP' },
      { value: 'COST', label: 'COST' },
      { value: 'DELE', label: 'DELE' },
      { value: 'DERR', label: 'DERR' },
      { value: 'INAC', label: 'INAC' },
      { value: 'RETG', label: 'RETG' },
      { value: 'SCRP', label: 'SCRP' },
      { value: 'UNKN', label: 'UNKN' },
      { value: 'COHO', label: 'COHO' },
      { value: 'POHO', label: 'POHO' },
      { value: 'RIST', label: 'RIST' },
      { value: 'RPUB', label: 'RPUB' },
      { value: 'RTRA', label: 'RTRA' },
    ],
  },
  {
    colName: 'UP_PSP_SHORT_DESC',
    displayName: 'Update Project Name',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'UP_ASU_STATUS_TEXT',
    displayName: 'ASU Update Status',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'UP_UI_PROJECT_DEF',
    displayName: 'Update Project ID',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'CON_RU_ID',
    displayName: 'RU Contract number',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'EQ_CON_NAME',
    displayName: 'RU Contract Class',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'CON_RU_STATUS',
    displayName: 'RU Contract Status',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: CONTRACT_STATUS_OPTIONS,
  },
  {
    colName: 'CON_RU_SUB_STATUS',
    displayName: 'RU Contract Sub Status',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'Other', label: 'Other' },
      { value: 'Dismantling', label: 'Dismantling' },
      { value: 'Active', label: 'Active' },
      {
        value: 'No Support wanted. Cust will take risk',
        label: 'No Support wanted. Cust will take risk',
      },
      { value: 'Customer Buyout', label: 'Customer Buyout' },
      { value: 'Scrapped', label: 'Scrapped' },
      { value: 'Not Running', label: 'Not Running' },
      { value: 'New Contract', label: 'New Contract' },
      { value: 'End of business', label: 'End of business' },
      { value: 'Expired', label: 'Expired' },
      { value: 'Cancelled', label: 'Cancelled' },
      {
        value: 'New System & Service with Siemens',
        label: 'New System & Service with Siemens',
      },
    ],
  },
  {
    colName: 'STATUS',
    displayName: 'HQ Contract Status',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: CONTRACT_STATUS_OPTIONS,
  },
  {
    colName: 'HC_STATUS_EXPLANATION',
    displayName: 'HQ Contract SubStatus',
    visible: false,
    isFilterable: true,
    filterType: 'select',
    selectOptions: [
      { value: 'Changes to Cost carriers', label: 'Changes to Cost carriers' },
      { value: 'Customer Buyout', label: 'Customer Buyout' },
      { value: 'End of Term', label: 'End of Term' },
      { value: 'Other', label: 'Other' },
      {
        value: 'No Support wanted. Cust will take risk',
        label: 'No Support wanted. Cust will take risk',
      },
      { value: 'Active', label: 'Active' },
      { value: 'Refused', label: 'Refused' },
      { value: 'Scrapped', label: 'Scrapped' },
      { value: 'New Contract', label: 'New Contract' },
      { value: 'Billing block', label: 'Billing block' },
      { value: 'Cancelled', label: 'Cancelled' },
      { value: 'Status Explan.', label: 'Status Explan.' },
      { value: 'End of business', label: 'End of business' },
      {
        value: 'Exchange (Follow-up contract?)',
        label: 'Exchange (Follow-up contract?)',
      },
      {
        value: 'Cancel for refinance - New Op Lease',
        label: 'Cancel for refinance - New Op Lease',
      },
      { value: 'New Owner', label: 'New Owner' },
      {
        value: 'Plant sold (Operator Change)',
        label: 'Plant sold (Operator Change)',
      },
      { value: 'Not Running', label: 'Not Running' },
      { value: 'Expired', label: 'Expired' },
      { value: 'Deleted', label: 'Deleted' },
      { value: 'Dismantling', label: 'Dismantling' },
      { value: '3rd party service', label: '3rd party service' },
      {
        value: 'New System & Service with Siemens',
        label: 'New System & Service with Siemens',
      },
      { value: 'Terminated', label: 'Terminated' },
    ],
  },
  {
    colName: 'CON_RU_START_DT',
    displayName: 'RU Contract Start Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'CON_RU_END_DT',
    displayName: 'RU Contract End Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'CON_RU_ID_RU',
    displayName: 'SAP Contract No',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },

  {
    colName: 'HQC_VAS_TYPE',
    displayName: 'VAS Type',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'HQC_VAS_TYPE_TEXT',
    displayName: 'VAS Type Description',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'HQC_VAS_LEVEL',
    displayName: 'VAS Level',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'HQC_VAS_TEXT',
    displayName: 'VAS Level Description',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'HQC_COUNTRY_START_DT',
    displayName: 'HQ Contract Start Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
  {
    colName: 'HQC_COUNTRY_END_DT',
    displayName: 'HQ Contract End Date',
    visible: false,
    isFilterable: true,
    filterType: 'text',
  },
];

export const INITIAL_PAGE_SIZE = 25;
export const INITIAL_ACTIVE_TAB = 'manual';
export const EXPANDED_PAGE_SIZE = 25;

export const PROJECT_STATUS = {
  draft: 'Draft',
  published: 'Published',
};

const QUERY_TABLE_TIMESTAMP_COLUMNS = [
  {
    colName: 'createdOn',
    label: 'createdOn',
    displayName: 'Created On',
    columns: 6,
    visible: true,
  },
  {
    colName: 'updatedon',
    label: 'updatedon',
    displayName: 'Updated On',
    columns: 6,
    visible: true,
  },
  {
    colName: 'createdBy',
    label: 'createdBy',
    displayName: 'Created By',
    columns: 6,
    visible: true,
  },
];

const QUERY_TABLE_FOOTER_COLUMNS = [
  {
    colName: 'comments',
    label: 'comments',
    displayName: 'Comments',
    columns: 5,
    visible: true,
  },
  {
    colName: 'action',
    label: 'action',
    displayName: 'Action',
    columns: 5,
    visible: true,
    isSortable: false,
  },
];

export const QUERY_TABLE_HEADERS_FILTERS = [
  {
    colName: 'id',
    label: 'id',
    displayName: 'Query ID',
    columns: 2,
    visible: true,
  },
  {
    colName: 'isFavourite',
    label: 'isFavourite',
    displayName: 'Favorite',
    columns: 2,
    visible: true,
    isSortable: false,
  },
  {
    colName: 'name',
    label: 'name',
    displayName: 'Query Name',
    columns: 5,
    visible: true,
  },
  {
    colName: 'projectId',
    label: 'projectId',
    displayName: 'Project ID',
    columns: 5,
    visible: true,
  },
  //  { colName: 'type', label: 'type', displayName: 'Filter Type', columns: 5, visible: false },
  ...QUERY_TABLE_TIMESTAMP_COLUMNS,
  ...QUERY_TABLE_FOOTER_COLUMNS,
];

export const QUERY_TABLE_HEADERS_TEMPLATE = [
  {
    colName: 'id',
    label: 'id',
    displayName: 'Template ID',
    columns: 2,
    visible: true,
  },
  {
    colName: 'isFavourite',
    label: 'isFavourite',
    displayName: 'Favorite',
    columns: 2,
    visible: true,
    isSortable: false,
  },
  {
    colName: 'name',
    label: 'name',
    displayName: 'Template Name',
    columns: 5,
    visible: true,
  },
  ...QUERY_TABLE_TIMESTAMP_COLUMNS,
  {
    colName: 'type',
    label: 'type',
    displayName: 'Template',
    columns: 5,
    visible: true,
    filterType: 'select',
  },
  ...QUERY_TABLE_FOOTER_COLUMNS,
  {
    colName: 'isDefault',
    label: 'isDefault',
    displayName: 'Default',
    columns: 5,
    visible: true,
  },
];

export enum QUERY_TYPE {
  LLM_QUERY = 'llm-query',
  MANUAL_QUERY = 'manual-query',
}
export enum USER_TYPE {
  UPDATE_USER = 'Update User',
  SUPPORT_USER = 'Admin User',
  STANDARD_USER = 'Standard User',
  BL_UM_USER = 'BL Update User',
  CS_UM_USER = 'CS Update User',
}

export enum QueryType {
  Standard = 'Standard',
  Project = 'Project',
  Template = 'Template',
  Public_Template = 'Public_Template',
}

export enum ROLE_TYPE {
  TEMPLATE_CREATOR_DEV = 'template_creator_dev',
  TEMPLATE_CREATOR_PROD = 'template_creator_prod',
  UPDATE_DEV = 'update_dev',
  UPDATE_PROD = 'update_prod',
  CS_UPDATE_DEV = 'cs_update_dev',
  CS_UPDATE_PROD = 'cs_update_prod',
  BL_UPDATE_DEV = 'bl_update_dev',
  BL_UPDATE_PROD = 'bl_update_prod',
  STANDARD_DEV = 'standard_dev',
  STANDARD_PROD = 'standard_prod',
}

interface RoleMapping {
  sourceRoles: string[];
  userType: string;
}

export const ROLE_MAPPINGS: RoleMapping[] = [
  {
    sourceRoles: [
      ROLE_TYPE.TEMPLATE_CREATOR_DEV,
      ROLE_TYPE.TEMPLATE_CREATOR_PROD,
    ],
    userType: USER_TYPE.SUPPORT_USER,
  },
  {
    sourceRoles: [ROLE_TYPE.CS_UPDATE_DEV, ROLE_TYPE.CS_UPDATE_PROD],
    userType: USER_TYPE.CS_UM_USER,
  },
  {
    sourceRoles: [ROLE_TYPE.BL_UPDATE_DEV, ROLE_TYPE.BL_UPDATE_PROD],
    userType: USER_TYPE.BL_UM_USER,
  },
  {
    sourceRoles: [ROLE_TYPE.STANDARD_DEV, ROLE_TYPE.STANDARD_PROD],
    userType: USER_TYPE.STANDARD_USER,
  },
  {
    sourceRoles: [ROLE_TYPE.UPDATE_DEV, ROLE_TYPE.UPDATE_PROD],
    userType: USER_TYPE.UPDATE_USER,
  },
];

export const ALL_SYSTEMS = 'All';
export type SaveAsFilterType = 'Standard' | 'Public_Template' | 'Template';
export type SaveFilterType =
  | 'Standard'
  | 'Project'
  | 'Template'
  | 'Public_Template';

export const CONTRACT_TYPE: string[] = [
  'HQ Contract',
  'RU Contract',
  'D&A Contract',
];

export const VAS_TYPE_OPTIONS: { id: string; name: string }[] = [
  { id: 'AS', name: 'Application Service' },
  { id: 'EV', name: 'Evolve' },
  { id: 'EX', name: 'Extended Warranty' },
  { id: 'HL', name: 'Headquarter fee logistics' },
  { id: 'HO', name: 'Headquarter fee others' },
  { id: 'HR', name: 'Headquarter fee rental' },
  { id: 'HS', name: 'Headquarter fee software' },
  { id: 'HT', name: 'Headquarter fee technical' },
  { id: 'IP', name: 'Injectable Phantom Training' },
  { id: 'IS', name: 'Integrated solution' },
  { id: 'LS', name: 'Local Service' },
  { id: 'LT', name: 'Local Training' },
  { id: 'PU', name: 'Pay per Use' },
  { id: 'RE', name: 'Remote Peer' },
  { id: 'RL', name: 'Regional Service SW Pack' },
  { id: 'RM', name: 'Guardian' },
  { id: 'RS', name: 'Regional Service' },
  { id: 'RY', name: 'Regional Service 1st Year' },
  { id: 'SA', name: 'Security Appliance Premium' },
  { id: 'SH', name: 'SRS Helpdesk service per demand' },
  { id: 'SI', name: 'SmartSimulator' },
  { id: 'SM', name: 'Software Maintenance' },
  { id: 'SO', name: 'SRS Helpdesk on-call service' },
  { id: 'SR', name: 'syngo Remote Services' },
  { id: 'TA', name: 'Teamplay Fleet Connect' },
  { id: 'TC', name: 'Training Course' },
  { id: 'TS', name: 'Technical Specialist' },
  { id: 'TV', name: 'Teamplay Fleet Vendor Agnostic' },
  { id: 'UM', name: 'Utilization Managment' },
  { id: 'UP', name: 'AdvanceNow' },
  { id: 'VE', name: 'Virtual Education Solution' },
  { id: 'VP', name: 'Virus Protection' },
];

export const VAS_LEVEL_OPTIONS: {
  vasType: string;
  level: string;
  name: string;
}[] = [
  { vasType: 'AS', level: '1', name: 'Application Service on site Training' },
  { vasType: 'AS', level: '2', name: 'Application Service remote Training' },
  { vasType: 'EV', level: '1', name: 'Evolve Initial' },
  { vasType: 'EV', level: '2', name: 'Evolve Stand Alone' },
  { vasType: 'EV', level: '3', name: 'Evolve Follow-up' },
  { vasType: 'EV', level: '4', name: 'Hardware new with WP' },
  { vasType: 'EV', level: '5', name: 'Hardware new without WP' },
  { vasType: 'EV', level: '6', name: 'Hardware new no checkup' },
  { vasType: 'EV', level: '7', name: 'Software subsequent with WP' },
  { vasType: 'EV', level: '8', name: 'Software subsequent without WP' },
  { vasType: 'EV', level: '9', name: 'Software subsequent no checkup' },
  { vasType: 'EX', level: '', name: 'Risk Coverage' },
  { vasType: 'EX', level: 'A', name: 'Risk Coverage Subscription' },
  { vasType: 'HL', level: '1', name: 'Headquarter fee logistics' },
  { vasType: 'HO', level: '1', name: 'Headquarter fee others' },
  { vasType: 'HR', level: '1', name: 'Headquarter fee rental' },
  { vasType: 'HS', level: '1', name: 'Headquarter fee software' },
  { vasType: 'HT', level: '1', name: 'Headquarter fee tech. support on-site' },
  { vasType: 'HT', level: '2', name: 'Headquarter fee tech. support remote' },
  { vasType: 'IP', level: '1', name: 'Injectable Phantom Training' },
  {
    vasType: 'IS',
    level: '1',
    name: 'IntgrSolution CinematicAnatomy PeriopSim',
  },
  { vasType: 'IS', level: '2', name: 'Skilitics abcdeSim ExpertGuidance' },
  { vasType: 'IS', level: '3', name: 'Cinematic Anatomy one time' },
  { vasType: 'LS', level: '', name: 'Local Service' },
  { vasType: 'LT', level: '', name: 'Local Training' },
  { vasType: 'PU', level: '', name: 'Pay per Use' },
  { vasType: 'RE', level: '', name: 'Remote Peer' },
  { vasType: 'RL', level: '', name: 'Regional Service SW Pack' },
  { vasType: 'RM', level: '1', name: 'Guardian DeviceGuard' },
  { vasType: 'RM', level: '2', name: 'Guardian DeviceGuard' },
  { vasType: 'RM', level: '3', name: 'Guardian DeviceGuard' },
  { vasType: 'RM', level: '4', name: 'Guardian DeviceGuard incl. TG / TM' },
  { vasType: 'RM', level: '5', name: 'Guardian DeviceGuard incl. TG / TM' },
  { vasType: 'RM', level: '6', name: 'Guardian DeviceGuard incl. TG / TM' },
  { vasType: 'RM', level: '7', name: 'Guardian 24h' },
  { vasType: 'RM', level: '8', name: 'Guardian 24h' },
  { vasType: 'RM', level: '9', name: 'Guardian 24h' },
  { vasType: 'RM', level: 'A', name: 'Guardian DeviceGuard incl. ImageGuard' },
  { vasType: 'RM', level: 'B', name: 'Guardian DeviceGuard incl. ImageGuard' },
  { vasType: 'RM', level: 'C', name: 'Guardian DeviceGuard incl. ImageGuard' },
  { vasType: 'RM', level: 'D', name: 'TubeGuard' },
  { vasType: 'RM', level: 'E', name: 'ImageGuard' },
  { vasType: 'RM', level: 'F', name: 'TubeGuard and ImageGuard' },
  { vasType: 'RM', level: 'G', name: 'Guardian DeviceGuard incl. TG and IG' },
  { vasType: 'RM', level: 'H', name: 'Guardian 24h and TubeGuard' },
  { vasType: 'RM', level: 'I', name: 'Guardian 24h and ImageGuard' },
  {
    vasType: 'RM',
    level: 'J',
    name: 'Guardian 24h and TubeGuard and ImageGuard',
  },
  { vasType: 'RS', level: '', name: 'Regional Service' },
  { vasType: 'RS', level: '1', name: 'Regional Service' },
  { vasType: 'RS', level: '2', name: 'Regional IT Admin Services' },
  { vasType: 'RY', level: '', name: 'Regional Service 1st Year' },
  { vasType: 'SA', level: '', name: 'Security Appliance Premium' },
  { vasType: 'SH', level: '1', name: 'SRS Helpdesk service per demand' },
  { vasType: 'SI', level: '1', name: 'SmartSimulator Package S' },
  { vasType: 'SI', level: '2', name: 'SmartSimulator Package M' },
  { vasType: 'SI', level: '3', name: 'SmartSimulator Package L' },
  { vasType: 'SI', level: '4', name: 'SmartSimulator Additional hours' },
  { vasType: 'SI', level: '5', name: 'SmartSimulator Trial Package' },
  { vasType: 'SI', level: '6', name: 'SmartSimulator Package customized' },
  { vasType: 'SI', level: '7', name: 'SmartSimulator ILT' },
  { vasType: 'SM', level: '1', name: 'e-Tune Trend' },
  { vasType: 'SM', level: '2', name: 'e-Tune Expert' },
  { vasType: 'SM', level: '3', name: 'e-Tune Department' },
  { vasType: 'SM', level: '4', name: 'e-Tune Clinic' },
  { vasType: 'SO', level: '1', name: 'SRS Helpdesk on-call service' },
  { vasType: 'SR', level: '1', name: 'syngo Remote Installation Service' },
  { vasType: 'SR', level: '2', name: 'syngo Remote Administrator Service' },
  { vasType: 'TA', level: '1', name: 'Teamplay Fleet Connect MAX' },
  { vasType: 'TA', level: '2', name: 'Teamplay Fleet Connect FIT' },
  { vasType: 'TC', level: '1', name: 'Training Course' },
  { vasType: 'TS', level: '1', name: 'Technical Specialist on-site' },
  { vasType: 'TS', level: '2', name: 'Technical Specialist remote' },
  { vasType: 'TV', level: '1', name: 'Teamplay Fleet Vendor Agnostic S' },
  { vasType: 'TV', level: '2', name: 'Teamplay Fleet Vendor Agnostic M' },
  { vasType: 'TV', level: '3', name: 'Teamplay Fleet Vendor Agnostic L' },
  { vasType: 'UM', level: '1', name: 'UM Basic' },
  { vasType: 'UM', level: '2', name: 'UM Advanced' },
  { vasType: 'UM', level: '3', name: 'UM Consulting' },
  { vasType: 'UP', level: '1', name: 'AdvanceNow' },
  { vasType: 'VE', level: '1', name: 'Virtual Education Solution' },
  { vasType: 'VP', level: '1', name: 'Virus P. Pro' },
  { vasType: 'VP', level: '2', name: 'Virus P. Select' },
  { vasType: 'VP', level: '3', name: 'Virus P. Premium' },
];

export {
  ALL_FIELDS,
  BACKEND_MAPPING_FIELDS,
  DA_FILTER_CRITERIA_FIELDS,
  DATE_FIELDS,
  DEFAULT_GROUP,
  EQ_STATUS_OPTIONS,
  EQ_SUBSTATUS_OPTIONS,
  FIELD_VALUE_OPTIONS,
  HQ_FILTER_CRITERIA_FIELDS,
  MATERIAL_NO_FIELDS,
  OPERATORS,
  OPERATORS_MAPPING_SYMBOL,
  RANGE_DATE_FILTER_TYPES,
  RU_FILTER_CRITERIA_FIELDS,
  SINGLE_VALUE_FIELDS,
  SYMBOLS_MAPPING_OPERATORS,
  TEXT_FIELDS,
} from './filter-criteria-core.constants';

  export const DEFAULT_CREATE_QUERY_MODE: CreateQueryMode = 'default';
  export const EMPTY_TEMPLATE = { guid: '', name: '', type: 'Personal' as const };
